export default "__VITE_ASSET__CfJGMp$r__"